import {Button, Input, Modal} from "antd";
import apiFactory from "../../../api";
import {openNotificationError, openNotificationSuccess} from "../../../utils/Utils";
import {useEffect, useState} from "react";

const StickerKeywordModal = ({
                                 open,
                                 onClose,
                                 sticker,
                                 onUpdated
                             }) => {
    const [keywordInput, setKeywordInput] = useState("");

    useEffect(() => {
        if (sticker) {
            setKeywordInput(sticker.keywords?.join(", ") || "");
        }
    }, [sticker]);

    const handleSubmit = async () => {
        try {
            const keywordsArr = keywordInput
                .split(",")
                .map((k) => k.trim())
                .filter((k) => k !== "");

            const res = await apiFactory.stickerApi.addKeyword({
                stickerId: sticker.stickerId,
                keywords: keywordsArr,
            });

            if (res?.status === 200) {
                openNotificationSuccess("Keywords updated successfully!");

                onUpdated && onUpdated(sticker.stickerId, keywordsArr);

                onClose();
            } else {
                openNotificationError("Failed to update keywords!");
            }
        } catch (err) {
            console.error(err);
            openNotificationError("Error updating keywords!");
        }
    };

    return (
        <Modal
            title="Edit Sticker Keywords"
            open={open}
            onCancel={onClose}
            onOk={handleSubmit}
            okText="Save"
        >
            <p className="mb-2 text-sm">Enter keywords separated by commas:</p>

            <Input
                value={keywordInput}
                onChange={(e) => setKeywordInput(e.target.value)}
                placeholder="Example: haha, lol, funny"
            />
        </Modal>
    );
}

export default StickerKeywordModal;